import { h, setChildren } from "../core/dom.js";
import { backLink } from "../components/common.js";
import { CHANGELOG } from "../lib/changelog.js";

// Patch notes — a plain-language history of what changed, newest first.
// Data lives in lib/changelog.js; the full developer history is in CHANGELOG.md at the repo root.
export default function Changelog() {
  const root = h("div", { class: "screen" });
  let current = "";

  // Highlight the running version (best-effort; the list still renders if this fails).
  fetch("/api/status").then((r) => r.json()).then((s) => { current = s?.version || ""; render(); }).catch(render);
  render();

  function entryCard(e) {
    const isCurrent = e.version === current;
    return h("div", { class: "card cl-entry" },
      h("div", { class: "cl-head" },
        h("span", { class: "cl-version" }, `v${e.version}`),
        isCurrent ? h("span", { class: "badge cl-current" }, "You're on this") : null
      ),
      h("div", { class: "cl-title" }, e.title),
      h("ul", { class: "cl-notes" }, ...e.notes.map((n) => h("li", null, n)))
    );
  }

  function render() {
    setChildren(root,
      backLink("Profile", "/profile"),
      h("h1", { style: { margin: "4px 0" } }, "What's new"),
      h("p", { class: "dim", style: { marginTop: 0, fontSize: ".85rem" } },
        "Recent updates to Kashtu, newest first."),
      h("div", { class: "mt" }, ...CHANGELOG.map(entryCard))
    );
  }

  return root;
}
